<template>
  <div class="container">
    <a-empty v-if="empty" :image="simpleImage" />
    <a-spin tip="Loading..." :spinning="spinning"></a-spin>
    <v-chart :options="options" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getLineChart } from '../api'
import { Empty } from 'ant-design-vue'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
export default {
  components: {
    'v-chart': ECharts,
  },
  data() {
    return {
      options: {},
      spinning: true,
      empty: false,
      unit: false,
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  computed: {
    ...mapGetters('app', ['company']),
  },
  mounted() {
    this.getChartData()
  },
  methods: {
    async getChartData() {
      const { data } = await getLineChart(this.company.code)

      if (data && data.xAxis.length !== 0) {
        this.spinning = false
        this.unit = true
        this.options = {
          title: {
            text: '',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data.xAxis,
            name: '(单位:年月日)',
            nameTextStyle: {
              color: '#000',
              fontWeight: 'bold',
            },
          },
          yAxis: {
            type: 'value',
            name: '（单位:元）',
            nameTextStyle: {
              color: '#000',
              fontWeight: 'bold',
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
          },
          series: [
            {
              data: data.series,
              type: 'line',
              smooth: true,
              areaStyle: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#c23532', // 0% 处的颜色
                    },
                    {
                      offset: 0.75,
                      color: '#c23532', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#d56f70', // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
              lineStyle: { width: 1, color: '#d56f70' },
              itemStyle: { color: 'red' },
              hoverAnimation: false,
              animation: true,
              animationEasing: 'cubicOut',
            },
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985',
              },
            },
            formatter: function(params) {
              return (
                '日期:' +
                params[0].axisValue +
                '<br />' +
                params[0].value +
                '元'
              )
            },
          },
        }
      } else {
        this.spinning = false
        this.empty = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  width: 80%;
  height: 600px;
  margin: 0 auto;
  .unit {
    text-align: right;
    font-size: 16px;
  }
}
/deep/.echarts {
  width: 100%;
  height: 100%;
}
/deep/.spin-content {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
</style>
